/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * How raw data translates to match/competition outcomes
 * @export
 */
export const ScoringStrategy = {
    FIRST_TO_WINS: 'FIRST_TO_WINS',
    SCORE_ACCUMULATION: 'SCORE_ACCUMULATION',
    MATCH_RESULT: 'MATCH_RESULT',
    PLACEMENT: 'PLACEMENT',
    METRIC_THRESHOLD: 'METRIC_THRESHOLD',
    TIME_BASED: 'TIME_BASED',
    CUSTOM: 'CUSTOM'
} as const;
export type ScoringStrategy = typeof ScoringStrategy[keyof typeof ScoringStrategy];


export function instanceOfScoringStrategy(value: any): boolean {
    for (const key in ScoringStrategy) {
        if (Object.prototype.hasOwnProperty.call(ScoringStrategy, key)) {
            if (ScoringStrategy[key as keyof typeof ScoringStrategy] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ScoringStrategyFromJSON(json: any): ScoringStrategy {
    return ScoringStrategyFromJSONTyped(json, false);
}

export function ScoringStrategyFromJSONTyped(json: any, ignoreDiscriminator: boolean): ScoringStrategy {
    return json as ScoringStrategy;
}

export function ScoringStrategyToJSON(value?: ScoringStrategy | null): any {
    return value as any;
}

export function ScoringStrategyToJSONTyped(value: any, ignoreDiscriminator: boolean): ScoringStrategy {
    return value as ScoringStrategy;
}

